export const TextFieldSizeEnum = {
        Small: 15,
        Medium: 250,
        Large: 1000,
        ExtraLarge: 4000,
        ExtraExtraLarge: 7000
}
